import Vue from 'vue'
import { consoleAuthClient } from './consoleAuthClient'

const state = Vue.observable({
  initialized: false,
  loading: false,
  user: null,
})

let initializePromise = null

async function initialize() {
  if (state.initialized) return
  if (!initializePromise) {
    state.loading = true
    initializePromise = consoleAuthClient.me()
      .then(user => { state.user = user })
      .catch(() => { state.user = null })
      .finally(() => {
        state.loading = false
        state.initialized = true
        initializePromise = null
      })
  }
  await initializePromise
}

async function signIn(credential) {
  state.loading = true
  try {
    state.user = await consoleAuthClient.login(credential)
    state.initialized = true
  } finally {
    state.loading = false
  }
}

async function signOut() {
  state.loading = true
  try { await consoleAuthClient.logout() }
  finally {
    state.user = null
    state.initialized = true
    state.loading = false
  }
}

export const consoleAuth = {
  state,
  initialize,
  signIn,
  signOut,
  isAuthenticated: () => Boolean(state.user),
}
